// extracted by mini-css-extract-plugin
export default {"geneName":"geneName__GeneName__efD2v","geneNamePrimary":"geneNamePrimary__GeneName__efD2v"};